import confetti from 'canvas-confetti';
import { prefersReducedMotion, useAppStore } from './store';

const FALLBACK = ['#0b6b6b', '#e09a1a', '#2f6fbf', '#16794a'];

/** Reads chart tokens from CSS so confetti matches the theme. */
const tokenColours = (): string[] => {
  if (typeof document === 'undefined') return FALLBACK;
  const style = getComputedStyle(document.documentElement);
  const colours = ['--chart-1', '--chart-2', '--chart-3', '--accent']
    .map((v) => style.getPropertyValue(v).trim())
    .filter(Boolean)
    .map((ch) => `#${ch.split(/\s+/).map((n) => Number(n).toString(16).padStart(2, '0')).join('')}`);
  return colours.length ? colours : FALLBACK;
};

/** True when celebrations are allowed (not Calm mode, no reduced motion). */
export const canCelebrate = (): boolean => !useAppStore.getState().calmMode && !prefersReducedMotion();

/**
 * A short, sound-free burst of confetti. No-op in Calm mode or with reduced motion.
 * Returns whether anything was shown.
 */
export const celebrate = (size: 'small' | 'big' = 'small'): boolean => {
  if (!canCelebrate()) return false;
  const colors = tokenColours();
  const base = { colors, disableForReducedMotion: true, zIndex: 80, ticks: size === 'big' ? 260 : 180 };
  if (size === 'big') {
    void confetti({ ...base, particleCount: 90, spread: 75, startVelocity: 42, origin: { x: 0.25, y: 0.7 }, angle: 60 });
    void confetti({ ...base, particleCount: 90, spread: 75, startVelocity: 42, origin: { x: 0.75, y: 0.7 }, angle: 120 });
  } else {
    void confetti({ ...base, particleCount: 60, spread: 60, startVelocity: 32, origin: { y: 0.7 } });
  }
  return true;
};
